import React, { useState, useEffect, useRef } from 'react';
import style from './MedicalOutDetails.module.css';
import HeadSub from '../../../../components/comm/HeadSub';
import TotalMedicalPaidDetailBox from '../../../../components/box/TotalMedicalPaidDetailBox';
import URL from '../../../../constants/url';
import { Link, useNavigate } from 'react-router-dom';


import { BottomSheet } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';

const MedicalOutDetails = () => {

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
        
            useEffect(() => {
                setOpen(false);
            }, []);
        
            function onDismiss() {
                setOpen(false);
            }
    
    return (
        <>
            <HeadSub title="진료 상세 " />

            <div id="sub-content" data-layout="white">     
                <div className='inner-wrap' data-pad-type="a">
                    
                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>기본정보</h2>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>예약일시</p>
                                        <span>24.12.12(월) 오후 01:30</span>
                                    </li>
                                    <li>
                                        <p>진료구분</p>
                                        <span>외래</span>
                                    </li>
                                    <li>
                                        <p>병원</p>
                                        <span>서울성모병원</span>
                                    </li>
                                    <li>
                                        <p>진료과</p>
                                        <span>신경외과</span>
                                    </li>
                                    <li>
                                        <p>의료진</p>
                                        <span>김미소</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>총 진료비</h2>
                            <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' onClick={() => setOpen(true)}>
                                <span>상세보기</span>
                            </button>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li>
                                        <p>수납금액</p>
                                        <span>21,000원</span>
                                    </li>
                                    <li>
                                        <p>상태</p>
                                        <span className={style["not-paid"]}>미수납</span>
                                        {/* <span className={style["paid"]}>수납완료</span> */}
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>약물 처방 내역</h2>
                            <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' onClick={()=> navigate(URL.HOSPITAL_PRESCRIPTIONDETAIL )}>
                                <span>상세보기</span>
                            </button>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}> 
                                <ul>
                                    <li data-list-type="column">
                                        <p>총 4건</p>
                                        <span>가스터정 20mg, 가스모틴정 5mg, 우루사정 200mg, 아크로펜정 100mg</span>
                                    </li>
                                </ul>

                                {/* 처방내역이 없을시 */}
                                {/* <p className={style["no-data"]}> 처방 내역이 없습니다.</p> */}
                            </div>
                        </div>
                    </div>


                    <div className={style["detail-box"]}>
                        <div className={style["head"]}>
                            <h2>진단 내역</h2>
                            <button className='btn' data-btn-type="fill-gray" data-btn-size='sm' onClick={()=> navigate(URL.HOSPITAL_INSPECTIONDETAIL)}>
                                <span>상세보기</span>
                            </button>
                        </div>
                        <div className={style["mid"]}>
                            <div className={style["inner-box"]}>
                                <ul>
                                    <li data-list-type="column">
                                        <p>총 4건</p>
                                        <span>일반 혈청 검사, 일반 혈액 검사, 일반 화학 검사, 혈액 응고 검사</span>
                                    </li>
                                </ul>

                                {/* 진단내역이 없을시 */}
                                {/* <p className={style["no-data"]}>진단 내역이 없습니다.</p> */}
                            </div>
                        </div>
                    </div>


                    
                 

                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className={style["bottom-fixed-box"]}>
                        <div className={style["inner-box"]}>

                            <div className={style['notice-txts']}>
                                <p>비대면 진료가 종료되었습니다</p>
                                <span>진료비를 수납하고 근처 약국으로 처방전을 전송하세요.</span>
                            </div>
                            <div className={style['btn-layout']}> 
                                <button className="btn" data-btn-type="fill-main-sub" data-btn-size="lg" onClick={()=>navigate(URL.PAY_MEDICAL_EXPENSES)}>
                                    <span>진료비 수납하기</span>
                                </button>
                                <button className="btn" data-btn-type="fill-main-sub" data-btn-size="lg">
                                    <span>처방전 확인하기</span>
                                </button>
                            </div>
                            
                        </div>
                    </div>               
                    {/* 하단 다음 버튼 영역 :: E */} 





                    <BottomSheet
                        scrollLocking={false} // 내부 스크롤을 위해 BottomSheet 스크롤 잠금 해제
                        expandOnContentDrag={false} // 내용 드래그로 확장 방지
                        open={open}
                        onDismiss={onDismiss}
                        snapPoints={({ minHeight }) => minHeight}
                        blocking={true}
                         >
                            <TotalMedicalPaidDetailBox onClose={onDismiss}/>
                    </BottomSheet>

                </div>
            </div>
            
        </>
    );
};

export default MedicalOutDetails;
